var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIbeifyFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0801 10.5468H18.3334V8.42685C17.7266 8.36375 17.1168 8.33259 16.5067 8.33352C14.6934 8.33352 13.4534 9.44018 13.4534 11.4668V13.2135H11.4067V15.5868H13.4534V21.6669H15.9067V15.5868H17.9467L18.2534 13.2135H15.9067V11.7002C15.9067 11.0002 16.0934 10.5468 17.0801 10.5468Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbeifyFbIcon);
export default __webpack_public_path__ + "static/media/ibeify_fb_icon.84f130a8499ab4406dce2c084dd011b2.svg";
export { ForwardRef as ReactComponent };